import { LogLevel } from '@azure/msal-browser';
import { logToAppInsights } from '../utils/AppInsights';
import Constants from './Constants';

/**
 * Enter here the user flows and custom policies for your B2C application
 * To learn more about user flows, visit: https://docs.microsoft.com/en-us/azure/active-directory-b2c/user-flow-overview
 * To learn more about custom policies, visit: https://docs.microsoft.com/en-us/azure/active-directory-b2c/custom-policy-overview
 */
export const b2cPolicies = {
  authorityDomain: Constants.ADB2C_CONNECTION.INSTANCE,
  tenant: Constants.ADB2C_CONNECTION.TENANT,
  names: {
    signUpSignIn: Constants.ADB2C_CONNECTION.SIGN_IN_POLICY,
    forgotPassword: Constants.ADB2C_CONNECTION.RESET_PASSWORD_POLICY,
  },
  authorities: {
    signUpSignIn: {
      authority: `${Constants.ADB2C_CONNECTION.INSTANCE}${Constants.ADB2C_CONNECTION.TENANT}/${Constants.ADB2C_CONNECTION.SIGN_IN_POLICY}`,
    },
    forgotPassword: {
      authority: `${Constants.ADB2C_CONNECTION.INSTANCE}${Constants.ADB2C_CONNECTION.TENANT}/${Constants.ADB2C_CONNECTION.RESET_PASSWORD_POLICY}`,
    },
  },
  scopes: Constants.ADB2C_CONNECTION.SCOPES,
};

/**
 * Configuration object to be passed to MSAL instance on creation.
 * For a full list of MSAL.js configuration parameters, visit:
 * https://github.com/AzureAD/microsoft-authentication-library-for-js/blob/dev/lib/msal-browser/docs/configuration.md
 */
export const msalConfig = {
  auth: {
    clientId: Constants.ADB2C_CONNECTION.APPLICATION_ID, // This is the ONLY mandatory field that you need to supply.
    authority: `${b2cPolicies.authorityDomain}${b2cPolicies.tenant}/${b2cPolicies.names.signUpSignIn}`, // Choose SUSI as your default authority.
    knownAuthorities: [b2cPolicies.authorityDomain], // Mark your B2C tenant's domain as trusted.
    redirectUri: '/', // You must register this URI on Azure Portal/App Registration. Defaults to window.location.origin
    postLogoutRedirectUri: '/', // Indicates the page to navigate after logout.
    navigateToLoginRequestUrl: true, // If "true", will navigate back to the original request location before processing the auth code response.
    scopes: Constants.ADB2C_CONNECTION.SCOPES,
  },
  cache: {
    cacheLocation: Constants.ADB2C_CONNECTION.CACHE_LOCATION, // Configures cache location. "sessionStorage" is more secure, but "localStorage" gives you SSO between tabs.
    storeAuthStateInCookie: false, // Set this to "true" if you are having issues on IE11 or Edge
  },
  system: {
    loggerOptions: {
      logLevel: getLogLevel(Constants.ADB2C_CONNECTION.MSAL_LOG_LEVEL),
      loggerCallback: (level, message, containsPii) => {
        if (containsPii) {
          return;
        }
        switch (level) {
          case LogLevel.Error:
            logToAppInsights('msal', message, 'error');
            return;
          case LogLevel.Info:
            logToAppInsights('msal', message, 'info');
            return;
          case LogLevel.Verbose:
            logToAppInsights('msal', message, 'info');
            return;
          case LogLevel.Warning:
            logToAppInsights('msal', message, 'warning');
            return;
          default:
            return;
        }
      },
    },
  },
};

function getLogLevel(logFromConfig) {
  logFromConfig = logFromConfig.toLowerCase();
  switch (logFromConfig) {
    case 'error':
      return LogLevel.Error;
    case 'info':
      return LogLevel.Info;
    case 'verbose':
      return LogLevel.Verbose;
    case 'warning':
      return LogLevel.Warning;
    default:
      return LogLevel.Info;
  }
}

/**
 * Add here the endpoints and scopes when obtaining an access token for protected web APIs. For more information, see:
 * https://github.com/AzureAD/microsoft-authentication-library-for-js/blob/dev/lib/msal-browser/docs/resources-and-scopes.md
 */
export const protectedResources = {
  api: {
    endpoint: Constants.API_BASE_URL,
    scopes: Constants.ADB2C_CONNECTION.SCOPES,
  },
};

export const loginRequest = {
  scopes: Constants.ADB2C_CONNECTION.SCOPES,
};

export const authRequest = {
  scopes: msalConfig.auth.scopes,
  redirectUri: '/redirect',
};
